module.exports = __webpack_public_path__ + "static/media/google-play-badge.928ad72a.svg";


/*****************
 ** WEBPACK FOOTER
 ** ./public/images/footer/google-play-badge.svg
 ** module id = 2138
 ** module chunks = 44
 **/